import { createContext, useContext, type ReactNode } from 'react';
import type { SlotContribution, SlotKey, WebExtension } from '../extension-types.js';

/**
 * The client's screen extensions, as compiled into this build. Core screens ask for a slot
 * by id and render whatever the client put there; an empty slot renders nothing.
 */

const ExtensionContext = createContext<WebExtension | null>(null);

export function ExtensionProvider({
  extension,
  children,
}: {
  extension: WebExtension | null;
  children: ReactNode;
}) {
  return <ExtensionContext.Provider value={extension}>{children}</ExtensionContext.Provider>;
}

export function useExtension(): WebExtension | null {
  return useContext(ExtensionContext);
}

export function useSlot<S extends SlotKey>(slot: S): SlotContribution<S>[] {
  const extension = useExtension();
  const contributions = (extension?.slots as Record<string, unknown[]> | undefined)?.[slot];
  return (contributions ?? []) as SlotContribution<S>[];
}
